import SharedSortableLists from './SharedSortableLists'
import ClientLibraryModuleView from './ClientLibraryModuleView'

class ClientLibraryModuleSort extends SharedSortableLists {
  reactTableComponent() {
    return ClientLibraryModuleView;
  }

  reactTableExtra() {
    return { roleType: this.roleType };
  }

  defaultSortKey() {
    return "modified_at"
  }

  sortData() {
    switch(this.sortKey) {
      case "modified_at":
        return this.sortBy({attr: "modified_at"})
        break;
      case "publication":
        return this.sortBy({attr: "sort_pub"})
        break;
      case "territory":
        return this.sortBy({attr: "sort_territory"})
        break;
      case "type":
        return this.sortBy({attr: "type"})
        break;
      case "size":
        return this.sortBy({attr: "raw_size"})
        break;
    }
  }
}

export default ClientLibraryModuleSort
